<template>
  <b-modal size="xl" v-model="showModalMap" id="modal-map" centered
           body-class="my-body" hide-footer hide-header @hidden="hide">
    <b-row style=" flex-grow : 1; margin-bottom: 0px" :class="{ hidden: true, 'show-hidden': !isHidden }">
      <b-col style="height: 600px; padding: 0; margin-bottom: 0; overflow: hidden" id="map_container_trace"
             ref="map_container_trace">
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import ZoomControl from 'mapbox-gl-controls/lib/zoom';
import LanguageControl from 'mapbox-gl-controls/lib/language';
import mapboxgl from 'mapbox-gl/dist/mapbox-gl';
import ClearIcon from 'vue-material-design-icons/CloseCircle.vue';

import distance from '@turf/distance'



import Vue from 'vue';


export default {
  name: "TraceMap",
  components: {
    ClearIcon,
  },
  data() {
    return {
      showModalMap: false,
      isHidden: true,
      trace: [],
      tasks: [],
      closeToggle: new class {
        constructor(parent) {
          this.parent = parent;
        }

        onAdd(map) {
          this.map = map;
          this.container = document.createElement('div');
          this.container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group mapboxgl-ctrl-styles';
          this.button = document.createElement('button');
          this.button.innerHTML = "&#x2715; Schließen";
          this.button.onclick = this.parent.closeMap;
          this.container.appendChild(this.button);
          return this.container;
        }

        onRemove() {
          this.container.parentNode.removeChild(this.container);
          this.map = undefined;
        }
      }(this),
    }
  },
  methods: {
    hide() {
      if (this.markers !== null) {
        for (let i = 0; i < this.markers.length; i++) {
          this.markers[i].remove();
        }
        this.markers = null;
      }
      this.items = [];
      if (this.map !== null) {
        this.map.remove();
        this.map = null;
      }
    },
    closeMap() {
      this.showModalMap = false;
      this.map = null;
    },
    showMapIfNeeded() {
      let bounds = new (mapboxgl.LngLatBounds);
      for (let i = 0; i < this.trace.length; i++) {
        bounds.extend(new mapboxgl.LngLat(this.trace[i].lon, this.trace[i].lat));
      }
      mapboxgl.accessToken = 'pk.eyJ1Ijoic3ZlbnBldGVyc2VuIiwiYSI6ImNqc3Z0YW82dDBhbDE0NXFpOGRzOXI4NWsifQ.Sq1nJiC3uKfA5yfYN8wR9w';
      this.map = new mapboxgl.Map({
        container: 'map_container_trace',
        style: 'mapbox://styles/mapbox/outdoors-v11',
        bounds: bounds,
        zoom: 18,
        minZoom: 5,
        maxPitch: 0,
        attributionControl: false
      });

      this.map.addControl(new ZoomControl(), 'bottom-right');
      this.map.addControl(this.closeToggle, 'top-right');
      const languageControl = new LanguageControl({
        language: 'de',
      });
      this.map.addControl(languageControl);

      this.markers = null;
      this.geojson = {};
      this.map.on('load', this.mapLoad);
    },
    removeMarkers() {
      if (this.markers === null || this.markers.length === 0) {
        this.markers = [];
        return;
      }
      for (let i = 0; i < this.markers.length; i++) {
        this.markers[i].remove();
      }
      this.markers = [];
    },
    drawMarkers() {
      this.removeMarkers()
      let finNormal = [];
      let finGeneral = [];
      for (let i = 0; i < this.trace.length; i++) {
        let trace = this.trace[i];
        // && trace.trace_type !== "fin"
        if(trace.trace_type === "fin") {
          finNormal.push(trace.task_t_id);
          finGeneral.push(trace.general_task_id);
          continue;
        }
        if (trace.trace_type !== "start" && trace.trace_type !== "end") {
          continue;
        }
        let el = document.createElement('div');
        el.className = trace.trace_type === 'start' ? 'marker_start' : trace.trace_type === 'end' ? 'marker_stop' : 'marker_fin';
        el.id = trace.id;
        let event = new Date(trace.timestamp.replace('Z',''));
        let time = event.toLocaleString('de-DE', {
          hour: '2-digit',
          minute: '2-digit',
        });
        const popup = new mapboxgl.Popup({ offset: 12 }).setHTML('<strong>'+time+'</strong>')
        let marker = new mapboxgl.Marker({
          element: el,
          anchor: 'center',
        })
            .setLngLat([trace.lon, trace.lat])
            .setPopup(popup)
            .addTo(this.map);
        this.markers.push(marker);
      }
      for (let i = 0; i < this.tasks.length; i++) {
        let task = this.tasks[i];
        if (task.lat === 0.0 && task.lon === 0.0) {
          continue;
        }
        let el = document.createElement('div');
        let fin = false;
        if (task.t_id) {
          if (finNormal.includes(task.t_id)) {
            fin = true;
          }
        } else if (finGeneral.includes(task.id)) {
          fin = true;
        }
        el.className = fin ? 'marker_fin' :'marker';
        el.id = task.id;
        const popup = new mapboxgl.Popup({ offset: 12 }).setHTML('<strong>'+(task.auftrag_was ? task.auftrag_was : task.gi_auf_ext ) +'</strong>')
        let marker = new mapboxgl.Marker({
          element: el,
          anchor: 'center',
        })
            .setLngLat([task.lon, task.lat])
            .setPopup(popup)
            .addTo(this.map);
        this.markers.push(marker);
      }
    },
    drawTrace() {
      let traceCoordinates = [];
      let finTraces = [];
      for (let i = 0; i < this.trace.length; i++) {
        traceCoordinates.push([this.trace[i].lon, this.trace[i].lat]);
        if (this.trace[i].trace_type === 'fin' && false) {
          console.log(this.trace[i])
          console.log(this.tasks)
          for (let j = 0; j < this.tasks.length; j++) {
            if (this.tasks[j].t_id === this.trace[i].task_t_id && this.tasks[j].lat !== 0.0 && this.tasks[j].lon !== 0.0) {
              let dist = Math.floor(distance([this.tasks[j].lon, this.tasks[j].lat], [this.trace[i].lon, this.trace[i].lat], {units: 'kilometers'}) * 1000);
              finTraces.push(
                  {
                    'type': 'Feature',
                    'geometry': {
                      'type': 'LineString',
                      'coordinates': [[this.tasks[j].lon, this.tasks[j].lat], [this.trace[i].lon, this.trace[i].lat]],
                    },
                    'properties': {
                      'distance_title': "" + dist + " m",
                    }
                  }
              )
              break;
            }
          }
        }
      }

      this.map.addSource('linestring', {
        'type': 'geojson',
        'data': {
          'type': 'FeatureCollection',
          'features': [
            {
              'type': 'Feature',
              'geometry': {
                'type': 'LineString',
                'coordinates': traceCoordinates
              }
            }
          ],
        }
      });
      this.map.addLayer({
        'id': 'route',
        'type': 'line',
        'source': 'linestring',
        'layout': {
          'line-join': 'round',
          'line-cap': 'round'
        },
        'paint': {
          'line-color': 'rgba(0,70,143,0.5)',
          'line-width': [
            'interpolate',
            ['exponential', 2],
            ['zoom'],
            10, ["*", 8, ["^", 2, -1]],
            24, ["*", 8, ["^", 2, 7]]
          ],
        }
      });

      this.map.addSource('fin_traces', {
        'type': 'geojson',
        'data': {
          'type': 'FeatureCollection',
          'features': finTraces,
        }
      });
      console.log(this.map.getSource("fin_traces"))
      this.map.addLayer({
        'id': 'fin_trace_route',
        'type': 'line',
        'source': 'fin_traces',
        'layout': {
          'line-join': 'round',
          'line-cap': 'round'
        },
        'paint': {
          'line-color': 'rgba(1,109,3,0.74)',
          'line-width': 3
        }
      });

      this.map.addLayer({
        "id": "symbols",
        "type": "symbol",
        "source": "fin_traces",
        "layout": {
          "symbol-placement": "line",
          "text-font": ["Open Sans Regular"],
          "text-field": "{distance_title}",
          "text-size": 15
        },
        "paint": {
          "text-color": "#202",
          "text-halo-color": "#fff",
          "text-halo-width": 2
        }
      });

      return finTraces;
    },
    drawLineStrings(finTraces) {
      if (finTraces.length === 0) {
        return;
      }
    },
    mapLoad() {
      setTimeout(() => {
        let finTraces =  this.drawTrace();
        this.drawLineStrings(finTraces);
        this.drawMarkers()
        this.map.resize();
        this.isHidden = false;
      });
    },
    removeLayer(id) {
      if (this.map.getLayer(id)) {
        this.map.removeLayer(id);
      }
    },
    removeSource(id) {
      if (this.map.getSource(id)) {
        this.map.removeSource(id);
      }
    },
    showMap(trace, tasks) {
      this.isHidden = true;
      this.markers = null;
      this.trace = trace;
      this.tasks = tasks;
      console.log(this.trace)
      console.log(this.tasks)

      if (this.trace.length === 0) {
        this.$emit('close-map', {reason: 'no-coords'})
        return;
      }
      this.showModalMap = true;
      this.$nextTick(() => {
        this.showMapIfNeeded();
      });
    },
  }
}
</script>

<style scoped>
.hoverable-icon:hover {
  cursor: pointer;
}

::v-deep .mapboxgl-popup-content {
  padding-bottom: 8px;
  padding-right: 15px;
}

::v-deep .mapboxgl-popup-close-button {
  margin-right: 2px;
}

</style>

<style>
.black {
  color: black;
}
.mapboxgl-popup {
  max-width: 600px !important;
  z-index: 2;
}
.mapboxgl-popup-close-button {
  font-size: 20px;
}

.marker {
  background-image: url('../../../public/mangel_marker.png');
  background-size: cover;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 1;
}

.marker_selected {
  background-image: url('../../../public/marker_selected.png');
  background-size: cover;
  width: 37px;
  height: 37px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 1;
}

.marker_fin {
  background-image: url('../../../public/marker_fin.png');
  background-size: cover;
  width: 37px;
  height: 37px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 1;
}

.marker_start {
  background-image: url('../../../public/start_marker.png');
  background-size: cover;
  width: 37px;
  height: 37px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 1;
}

.marker_stop {
  background-image: url('../../../public/stop_marker.png');
  background-size: cover;
  width: 37px;
  height: 37px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 1;
}

.my-body {
  padding: 0 !important;
}

.hidden {
  opacity: 0;
  transition: opacity 0.1s ease-in;
}

.mapboxgl-popup-close-button {
  outline: none !important;
}

.show-hidden {
  opacity: 1;
}


.sidebar2 {
  visibility: hidden;
  width: 0;
  position: absolute;
  z-index: 1 !important;
  overflow-x: hidden;
  -webkit-transition: 0.5s;
  transition: 0.5s;
  -moz-transition: 0.5s;
  padding: 0;
  top: 50px;
  -webkit-transition-property: width, visibility;
  transition-property: width, visibility;
  -moz-transition-property: width, visibility;
  -webkit-transition-timing-function: ease;
  transition-timing-function: ease;
  -moz-transition-timing-function: ease;
}

.mapboxgl-ctrl-top-left {
  display: flex;
  display: flex;
  display: -moz-flex;
  display: -webkit-flex;
  display: -o-flex;
}

.mapboxgl-ctrl-top-left .mapboxgl-ctrl {
  display: flex;
  display: flex;
  display: -moz-flex;
  display: -webkit-flex;
  display: -o-flex;
}
.mapboxgl-ctrl-top-left .mapboxgl-ctrl-group button+button {
  border-left: 1px solid #ddd;
  border-top: none;
}

.my-custom-control {
  color: #f00;
  background: #000;
  padding: 8px;
  border-radius: 4px;
  margin: 8px;
}

</style>
